/* eslint-disable no-param-reassign */
import { Swiper, Navigation, Pagination } from 'swiper';

class SyndicatedVenuesGallery {
  constructor() {
    this.switcherElement = '';
    this.swiper = '';
    this.swiperBlock = '';
    this.venueName = '';
    this.blockClass = 'venues-gallery';
  }

  setSwitcherElement(element) {
    this.switcherElement = element;
    this.toggleSwitcherOptions();

    if (element.tagName === 'LI') {
      this.venueName = element.textContent.trim();
    }

    if (this.venueName) {
      element.closest(`.${this.blockClass}__switcher`)
        .querySelector(`.${this.blockClass}__switcher-value`)
        .textContent = this.venueName;

      this.disablePrevious(element);
      this.swiperBlock = element.closest(`.${this.blockClass}`).querySelector(`.${this.blockClass}__venue[data-title="${this.venueName}"]`);
      this.activateGallery();
      this.swiperBlock.closest('.venues-gallery').querySelector('.venues-gallery__switcher-inner').focus();
    }

    this.venueName = '';
  }

  disablePrevious = (element) => {
    const previousSwiperBlock = Array.from(element.closest(`.${this.blockClass}`).querySelectorAll(`.${this.blockClass}__venue .swiper-container`))
      .find((block) => block.swiper !== undefined);

    const previousActivatedImages = Array.from(element.closest(`.${this.blockClass}`).querySelectorAll(`.${this.blockClass}__venue .${this.blockClass}__slide--single`))
      .find((block) => block.classList.contains('active'));

    if (previousSwiperBlock) {
      previousSwiperBlock.swiper.destroy();
      previousSwiperBlock.swiper = undefined;
    }

    if (previousActivatedImages) {
      previousActivatedImages.classList.remove('active');
    }
  };

  activateGallery = () => {
    if (this.swiperBlock.querySelector('.swiper-container')) {
      this.swiperBlock = this.swiperBlock.querySelector('.swiper-container');
      this.initSwiper();
    } else {
      this.swiperBlock.querySelector('.venues-gallery__slide').classList.add('active');
    }
  };

  initSwiper = () => {
    const venueSlider = this.swiperBlock;
    const venueBlock = venueSlider.closest(`.${this.blockClass}__venue`);
    let { swiper } = venueSlider;

    if (venueBlock.classList.contains('container')) {
      return;
    }

    if (swiper && typeof swiper.destroy === 'function') {
      swiper.destroy();
      swiper = null;
    }

    swiper = new Swiper(venueSlider, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      centeredSlides: false,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: venueBlock.querySelector('.swiper-button-next'),
        prevEl: venueBlock.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: venueBlock.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: (index, className) => `<span class="${className}" tabindex="0" aria-label="Slide ${index + 1}"></span>`,
      },
      watchSlidesProgress: true,
      watchOverflow: true,
      loop: false,
    });
  };

  toggleSwitcherOptions = () => {
    const parentElement = this.switcherElement.closest(`.${this.blockClass}__switcher`);
    parentElement.classList.toggle(`${this.blockClass}__switcher--open`);
  };

  run = () => {
    const switchers = document.querySelectorAll(`.${this.blockClass}__switcher-inner`);
    const switchersItems = document.querySelectorAll(`.${this.blockClass}__switcher-list li`);
    const blockContainers = document.querySelectorAll(`.${this.blockClass}`);

    blockContainers.forEach((blockContainer) => {
      this.swiperBlock = blockContainer.querySelector(`.${this.blockClass}__venue`);
      this.activateGallery();
    });

    switchers.forEach((switcher) => {
      switcher.addEventListener('click', () => {
        this.setSwitcherElement(switcher);
      });

      switcher.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          this.setSwitcherElement(switcher);
        }
      });
    });

    switchersItems.forEach((switcherItem) => {
      switcherItem.addEventListener('click', () => {
        this.setSwitcherElement(switcherItem);
      });

      switcherItem.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          this.setSwitcherElement(switcherItem);
        }
      });
    });

    document.addEventListener('focusin', (event) => {
      if (!event.target.closest(`.${this.blockClass}__switcher`)) {
        document.querySelectorAll(`.${this.blockClass}__switcher`).forEach((switcher) => {
          switcher.classList.remove(`${this.blockClass}__switcher--open`);
        });
      }
    });

    document.addEventListener('keyup', (event) => {
      const { target } = event;

      if (target.classList.contains('swiper-button') || target.classList.contains('swiper-pagination-bullet')) {
        if (event.keyCode === 13 || event.keyCode === 32) {
          target.click();

          if (target.classList.contains('swiper-button-disabled')) {
            const swiperControlsElement = target.closest('.swiper-controls');
            if (swiperControlsElement) {
              const swiperBullet = swiperControlsElement.querySelector(
                target.classList.contains('swiper-button-next')
                  ? '.swiper-pagination-bullet:last-child'
                  : '.swiper-pagination-bullet:first-child',
              );
              if (swiperBullet) {
                swiperBullet.focus();
              }
            }
          }
        }
      }

      if (target.classList.contains('venues-gallery__switcher-value') || target.classList.contains('venues-gallery__switcher-inner')) {
        if (event.keyCode === 27) {
          this.toggleSwitcherOptions();
          target.closest('.venues-gallery__switcher-inner').focus();
        }
      }
    });
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const SyndicatedVenuesGalleryObject = new SyndicatedVenuesGallery();
  SyndicatedVenuesGalleryObject.run();
});
